/*-----------------------------------------------------------------------------/
/ Custom Theme JS
/-----------------------------------------------------------------------------*/

// Insert any custom theme js here...

document.addEventListener('DOMContentLoaded', function() {
  $('#load-all-images').on('click', function() {
    let totalHiddenCounter = $('.d-none').length;
    $('.d-none').each(function(e, i) {
      $(this).addClass(totalHiddenCounter === 1 ? 'expanded-full' : 'expanded');
      $(this).removeClass('d-none');
    });
    $(this).remove();
  });

  // 2026-08-24: Slick-slideren til mobil er fjernet. slick-carousel-biblioteket
  // ligger ikke i temaet, og .dynamic-slick-grid-container findes ikke i markuppen,
  // saa koden kastede kun en fejl i konsollen.

});

const MOBILE_BREAKPOINT = 768;
const MAX_VISIBLE_SWATCHES_MOBILE = 5;
const MAX_VISIBLE_SWATCHES_DESKTOP = 5;

function handleSwatches() {
  const productCards = document.querySelectorAll('.product-card');
  if (!productCards.length) return;

  const isMobile = window.innerWidth < MOBILE_BREAKPOINT;

  const currentMaxSwatches = isMobile ? MAX_VISIBLE_SWATCHES_MOBILE : MAX_VISIBLE_SWATCHES_DESKTOP;

  productCards.forEach((card) => {
    const swatchWrapper = card.querySelector('.swatches .product-item__linked');
    if (!swatchWrapper) return;

    const swatches = Array.from(swatchWrapper.querySelectorAll('.product-item__linked-item'));

    const existingCountElements = swatchWrapper.querySelectorAll('.swatch-more-count');
    existingCountElements.forEach(el => el.remove());

    swatches.forEach(swatch => {
      swatch.classList.remove('swatch-hide');
    });

    if (swatches.length > currentMaxSwatches) {
      swatches.forEach((swatch, index) => {
        if (index >= currentMaxSwatches) {
          swatch.classList.add('swatch-hide');
        }
      });

      const countElement = document.createElement('a');
      countElement.href = swatchWrapper.dataset.url;
      countElement.classList.add('swatch-more-count');
      countElement.textContent = `${swatches.length} farver`;
      swatchWrapper.appendChild(countElement);
    }
  });
}

document.addEventListener('DOMContentLoaded', handleSwatches);
window.addEventListener('resize', handleSwatches);

// Produktkort der loades bagefter (anbefalinger, filtrering, "load more")
// findes ikke ved DOMContentLoaded — kør igen når nye kort dukker op.
document.addEventListener('DOMContentLoaded', function () {
  let pending = null;

  new MutationObserver(function (mutations) {
    const gotNewCards = mutations.some(function (mutation) {
      return Array.from(mutation.addedNodes).some(function (node) {
        if (node.nodeType !== 1) return false;
        return node.matches('.product-card') || node.querySelector('.product-card');
      });
    });

    if (!gotNewCards) return;

    clearTimeout(pending);
    pending = setTimeout(handleSwatches, 100);
  }).observe(document.body, { childList: true, subtree: true });
});
